import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./PhotographersPage.css";

// JDS
import {
  Button,
  Container,
  DropdownMenuGroup,
  DropdownMenuItem,
  Notifications,
  SearchBox,
  Text,
  Tooltip,
} from "@jds/core";

// MUI
import { Box, Typography } from "@mui/material";

// Local
import AddButton from "../components/UI/Buttons/AddButton";
import JdsModal from "../components/UI/JdsModal";
import InviteGuestForm from "../components/UI/Form/InviteGuestForm";
import useApiHttp from "../hooks/use-http";
import JdsMenu from "../components/UI/JdsMenu";
import Loader from "../components/UI/Loader/Loader";
import EmptyState from "../components/NoData/EmptyState";
import PageLoader from "../components/UI/Loader/PageLoader";
import PhotographerCard from "../components/UI/Cards/PhotographerCard";
import EditPhotographerForm from "../components/UI/Form/EditPhotographerForm";
import PhotographerListModal from "../components/UI/PhotographerListModal";

const FilterBtn = (props) => (
  <Tooltip label="Click here to filter" position="bottom">
    <Button
      iconLeft={"IcFilterMultiple"}
      label="Filter"
      kind="secondary"
      size="small"
      {...props}
    />
  </Tooltip>
);

export default function PhotographersPage() {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [photograherData, setPhotograherData] = useState();
  const [photograherList, setPhotograhersList] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [pageHeading, setPageHeading] = useState(
    location?.state?.navigate == "BLOCKED" ? "Blocked" : "All"
  );
  const [isAddPhotograherModalClose, setAddPhotograherModalClose] =
    useState(true);
  const [isShareModalClose, setShareModalClose] = useState(true);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [clearFileBlob, setClearFileBlob] = useState(true);
  const [actionHandlerSuccess, setActionHandlerSuccess] = useState(true);
  const [filterListIndex, setFilterListIndex] = useState(
    location?.state?.navigate == "BLOCKED" ? 1 : 0
  );
  const [isEditPhotographerModalClosed, setIsEditPhotographerModalClose] =
    useState(true);
  const [isFaceModalClosed, setIsFaceModalClose] = useState(true);

  const [editPhotographerData, setEditPhotographerData] = useState({});

  const filterList = ["all", "blocked", "attending"];
  const { sendRequest: getPhotograherData, isLoading: photograherDataLoading } =
    useApiHttp();

  const { sendRequest: searchGuestApi, isLoading: searchIsLoading } =
    useApiHttp();

  const { sendRequest: actionRequest, isLoading: isActionLoading } =
    useApiHttp();

  const getPhotographerHandler = (filter) => {
    getPhotograherData(
      {
        url: `event-attendee/${filter !== "all" ? filter : "all"
          }/${eventId}/photographers?page=${page}&size=10`,
      },
      null,
      (data) => {
        if (page == 0) {
          setPhotograherData(data);
          setPhotograhersList(data?.results);
          setLastPage(data?.lastPage);
        } else {
          setPhotograherData(data);
          setPhotograhersList((prev) => [...prev, ...data?.results]);
          setLastPage(data?.lastPage);
        }
        setClearFileBlob((pre) => !pre);
      }
    );
  };

  const searchGuestHandler = (searchValue) => {
    searchGuestApi(
      {
        // url:
        //   filterListIndex == 0
        //     ? `event-attendee/search/${eventId}/photographer?nameQuery=${searchValue}&page=${page}&size=20`
        //     : `event-attendee/attendees_search/${eventId}/blocked?nameQuery=${searchValue}&page=${page}&size=20&userRole=photographers`,
        url: `event-attendee/search/${filterListIndex === 0 ? "all" : filterList[filterListIndex]
          }/${eventId}/photographers?nameQuery=${searchValue}&page=${page}&size=20`,
      },
      null,
      (data) => {
        if (page == 0) {
          setPhotograherData(data);
          setPhotograhersList(data?.data);
          setLastPage(data?.lastPage);
        } else {
          setPhotograherData(data);
          setPhotograhersList((prev) => [...prev, ...data?.data]);
          setLastPage(data?.lastPage);
        }
      }
    );
  };

  const restoreHandler = (userId) => {
    setActionHandlerSuccess(false);
    actionRequest(
      {
        url: "event-attendee/restore",
        method: "PUT",
        body: {
          eventId,
          userId,
        },
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "guest-action",
          title: data.message,
        });
        setActionHandlerSuccess(true);
        if (page !== 0) {
          setPage(0);
        } else {
          getPhotographerHandler(filterList[filterListIndex]);
        }
      }
    );
  };

  const blockHandler = (userId) => {
    setActionHandlerSuccess(false);
    actionRequest(
      {
        url: "event-attendee/delete",
        method: "DELETE",
        body: {
          eventId,
          userId,
        },
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "photographer-block-action",
          title: data.message,
        });
        setActionHandlerSuccess(true);
        if (page !== 0) {
          setPage(0);
        } else {
          getPhotographerHandler(filterList[filterListIndex]);
        }
      }
    );
  };

  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (photograherDataLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [photograherDataLoading, lastPage]
  );

  useEffect(() => {
    if (searchValue.length > 2) {
      searchGuestHandler(searchValue);
    } else {
      getPhotographerHandler(filterList[filterListIndex]);
    }
  }, [page]);

  return (
    <>
      <Container fullWidth direction="column" gap={64}>
        <Container
          fullWidth
          horizontalAlign="space-between"
          className="photographerpage-outerwrapper"
        >
          <Box className="photographerpage-heading">
            <Box mb={1}>
              <Text text={`${pageHeading} Photographers`} appearance="heading-xs" />
            </Box>
            <Text text={`Count: ${photograherData?.count ?? 0}`} appearance="body-m-bold" color="primary-grey-80" />
          </Box>
          <Container
            direction="row"
            horizontalAlign="right"
            verticalAlign="center"
            gap={16}
            className="photographerpage-buttonswrapper"
          >
            <Box sx={{ "& .j-JDSButton-jds-text": { textWrap: "nowrap" } }}>
              <Tooltip label="Click here to add photographer" position="bottom">
                <AddButton
                  kind="primary"
                  label="Add Photographer"
                  size="small"
                  onClick={() => setAddPhotograherModalClose(false)}
                />
              </Tooltip>
            </Box>

            <>
              <JdsModal
                header="Add Photographer"
                size="m"
                kind="dialog"
                close={isAddPhotograherModalClose}
                onClose={() => {
                  setAddPhotograherModalClose(true);
                }}
              >
                {!isAddPhotograherModalClose && (
                  <InviteGuestForm
                    role="PHOTOGRAPHER"
                    onSuccess={() => {
                      setPhotograhersList([]);
                      setPageHeading("All");
                      setSearchValue("");
                      setFilterListIndex(0);
                      if (page !== 0) {
                        setPage(0);
                      } else {
                        getPhotographerHandler(filterList[0]);
                      }
                      setAddPhotograherModalClose(true);
                    }}
                  />
                )}
              </JdsModal>
            </>
            <SearchBox
              value={searchValue}
              onChange={(e) => {
                const searchValue = e.target.value;
                setSearchValue(searchValue);
                if (page !== 0) {
                  setPage(0);
                }
                if (searchValue.length > 2) {
                  searchGuestHandler(searchValue);
                } else if (searchValue.length == 0) {
                  getPhotographerHandler(filterList[filterListIndex]);
                }
              }}
              label="Search Photographers"
              prefix="IcSearch"
            />
            <JdsMenu
              trigger={{ component: FilterBtn }}
              onSelect={(value) => { }}
            >
              <DropdownMenuGroup hideBottomDivider>
                <DropdownMenuItem
                  value="ALL"
                  prefix={"IcProfile"}
                  label="All Photographers"
                  onClick={() => {
                    setPageHeading("All");
                    setSearchValue("");
                    setFilterListIndex(0);
                    if (page !== 0) {
                      setPage(0);
                    } else {
                      getPhotographerHandler(filterList[0]);
                    }
                  }}
                />
                <DropdownMenuItem
                  value="ATTENDING"
                  prefix={"IcSubscription"}
                  label="Attending Photographers"
                  onClick={() => {
                    setPageHeading("Attending");
                    setFilterListIndex(2);
                    setSearchValue("");
                    if (page !== 0) {
                      setPage(0);
                    } else {
                      getPhotographerHandler(filterList[2]);
                    }
                  }}
                />
                <DropdownMenuItem
                  value="BLOCKED"
                  prefix={"IcBlocked"}
                  label="Blocked Photographers"
                  onClick={() => {
                    setPageHeading("Blocked");
                    setFilterListIndex(1);
                    setSearchValue("");
                    if (page !== 0) {
                      setPage(0);
                    } else {
                      getPhotographerHandler(filterList[1]);
                    }
                  }}
                />
              </DropdownMenuGroup>
            </JdsMenu>
          </Container>
        </Container>
        {photograherList?.length > 0 ? (
          <>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: `repeat(auto-fit, minmax(284px, ${
                  photograherList.length > 2 ? "1fr" : "350px"
                }))`,
                gap: "60px",
                width: "100%",
              }}
            >
              {photograherList.map((photographer, i) => (
                <div
                  key={photographer?.id || photographer?.userId || i}
                  ref={i + 1 == photograherList.length ? lastElementRef : null}
                >
                  <PhotographerCard
                    data={photographer}
                    role="PHOTOGRAPHER"
                    blockAction={blockHandler}
                    restoreAction={restoreHandler}
                    isActionLoading={isActionLoading}
                    isActionSuccess={actionHandlerSuccess}
                    profileUpdate={() => {
                      if (page !== 0) {
                        setPage(0);
                      } else {
                        getPhotographerHandler(filterList[filterListIndex]);
                      }
                    }}
                    clearFileBlob={clearFileBlob}
                    setIsEditPhotographerModalClose={() => {
                      setEditPhotographerData(photographer);
                      setIsEditPhotographerModalClose(false);
                    }}
                    setIsFaceModalClose={() => {
                      setEditPhotographerData(photographer);
                      // setIsFaceModalClose(false);
                      navigate(
                        `/home/events/photographers/${eventId}/photographer-cluster-list/${photographer?.userId}`,
                        {
                          state: {
                            firstName: photographer?.firstName,
                            lastName: photographer?.lastName,
                            user: "PG",
                            indexedProfileThumbnail:
                              photographer?.profilePictureThumbnailUrl,
                            indexedProfilePic: photographer?.profilePictureUrl,
                          },
                        }
                      );
                    }}
                  />
                </div>
              ))}
            </Box>
            <Container fullWidth horizontalAlign="center">
              {((photograherDataLoading && page !== 0) ||
                (searchIsLoading && page !== 0)) && <Loader />}
            </Container>
          </>
        ) : (
          <EmptyState
            title="No photographers found!"
            subtitle=""
            action={false}
          />
        )}
        {((photograherDataLoading && page === 0) ||
          (searchIsLoading && page === 0)) && (
            <PageLoader open={photograherDataLoading || searchIsLoading} />
          )}
      </Container>
      <JdsModal
        header={`Edit Photographer`}
        kind="custom"
        close={isEditPhotographerModalClosed}
        onClose={() => setIsEditPhotographerModalClose(true)}
      >
        {!isEditPhotographerModalClosed && (
          <EditPhotographerForm
            data={{
              ...editPhotographerData,
              userId: editPhotographerData?.id,
              profilePic: editPhotographerData?.profilePictureThumbnailUrl
                ? editPhotographerData?.profilePictureThumbnailUrl
                : null,
              role: "PHOTOGRAPHER",
              profileFile: editPhotographerData?.profileFile,
            }}
            onSuccess={(photographer, update) => {
              if (update) {
                setPhotograhersList((pre) => {
                  const updateData = pre.map((item) => {
                    if (item.id == photographer.id) {
                      return {
                        ...item,
                        firstName: photographer.firstName,
                        lastName: photographer.lastName,
                        email: photographer?.email,
                        profileFile: photographer?.profilePicture,
                      };
                    } else {
                      return item;
                    }
                  });
                  return updateData;
                });
              } else {
                if (page !== 0) {
                  setPage(0);
                } else {
                  getPhotographerHandler(filterList[filterListIndex]);
                }
                // setPhotograhersList((pre) => {
                //   const updateData = pre.filter(
                //     (item) => item.id !== photographer.id
                //   );
                //   return updateData;
                // });
              }
            }}
            closeModal={() => setIsEditPhotographerModalClose(true)}
          />
        )}
      </JdsModal>

      <JdsModal
        header={`${editPhotographerData?.firstName +
          " " +
          editPhotographerData?.lastName || "Unnamed"
          }`}
        kind="custom"
        close={isFaceModalClosed}
        onClose={() => {
          setIsFaceModalClose(true);
          // window.location.reload();
        }}
      >
        {!isFaceModalClosed && (
          <PhotographerListModal data={editPhotographerData} />
        )}
      </JdsModal>
    </>
  );
}
